{
  "fr": {
    "courseBookmark": {
      "title": "Mes formations favorites",
      "emptyState": {
        "title": "Votre liste de favoris est encore vide",
        "body": "Vous n'avez pas encore ajouté de formations à vos favoris. Vous pouvez ajouter les formations qui vous plaisent à votre liste de favoris en cliquant simplement sur le <i class='bi bi-heart text-primary'></i>."
      },
      "links": {
        "toCourses": "Découvrir les formations"
      }
    }
  }
}
